export const SET_TOOLTIP = "SET_TOOLTIP";
export const CLEAR_TOOLTIP = "CLEAR_TOOLTIP";

export const NEW_ERROR = "NEW_ERROR";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const SET_SETTINGS = "SET_SETTINGS";

export const ADD_DATAEVENTS = 'ADD_DATAEVENTS';
export const ADD_NEWSEVENT = 'ADD_NEWSEVENT';



// WEBPACK FOOTER //
// ./src/store/constants/ActionTypes.js